import { routes } from "@/lib/routes";
import type { LandvestHandoffUtm } from "@/lib/land-check/freeze";

/**
 * Lease and hunting-lease articles. Their readers are landowners letting land,
 * not Ökopunkte buyers, so these pages lead with the LandVest Flächenanalyse
 * (catch-all content route) and keep Klara's invitation card closed
 * (ChatWidget). Roof and car-park leasing are left out: the Flächenanalyse
 * assesses open land.
 */
export const PACHT_ARTICLE_PATHS: readonly string[] = [
  routes.content.landVerpachten,
  routes.content.landVerpachtenSteuer,
  routes.content.pachtvertraege,
  routes.content.agrarpacht,
  routes.content.agrarpachtPreis,
  routes.content.agrarpachtSteuererklaerung,
  routes.content.waldVerpachten,
  routes.content.jagdpachtPreise,
  routes.content.jagdpachtSteuer,
  routes.content.jagdpachtBerechnung,
];

/** UTM of the Flächenanalyse link on a lease article. */
export const PACHT_ARTICLE_UTM: LandvestHandoffUtm = {
  medium: "article",
  campaign: "pacht-article",
};

export function isPachtArticlePath(pathname: string): boolean {
  return PACHT_ARTICLE_PATHS.includes(pathname);
}
